export const environment = {
    production: true,
    KEYCLOAK_URL: 'https://osce.wirtualnaklinika.com/auth/realms/wk-dev',
    KEYCLOAK_REALM: 'wk-dev',
    KEYCLOAK_CLIENT_ID: 'wk-osce',
    keycloakCredentials: false as false | { token: string; id: number },
};